import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@app/services';
import { DirectivesModule, PipesModule, SharedModule } from '@app/shared';
import { Subscription } from 'rxjs';
import { AuthService } from '..';
import { AuthShellComponent } from '../shell';

@Component({
  imports: [SharedModule, DirectivesModule, PipesModule, AuthShellComponent],
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
})
export class ConfirmComponent extends BaseService implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);

  params$: Subscription;
  private isConfirming = false;

  ngOnInit(): void {
    this.params$ = this.route.queryParams.subscribe(this.onParamsChange.bind(this));
  }

  ngOnDestroy(): void {
    this.params$.unsubscribe();
  }

  onParamsChange(params: { token?: string; verify?: string }): void {
    const token: string = (params.token ?? params.verify ?? '').trim();
    void this.confirm(token);
  }

  async confirm(token: string): Promise<void> {
    if (this.isConfirming) {
      return;
    }
    this.isConfirming = true;
    if (!token) {
      void this._alert.error('Link de confirmação inválido.');
      void this.router.navigateByUrl('/signin');
      return;
    }
    this._spin.start();
    await this.authService
      .confirm(token)
      .then(() => {
        void this._alert.success('E-mail confirmado. Magic Link, código e WhatsApp já podem ser usados.');
      })
      .catch(() => {
        void this._alert.error('Não foi possível confirmar o e-mail. Solicite um novo link.');
      })
      .finally(() => {
        this._spin.stop();
        void this.router.navigateByUrl('/');
      });
  }
}
